import script from "./OurStory.vue?vue&type=script&setup=true&lang=js"
export * from "./OurStory.vue?vue&type=script&setup=true&lang=js"

import "./OurStory.vue?vue&type=style&index=0&id=b233cd72&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b233cd72"]])

export default __exports__